import React, {FC} from 'react'

const JiraIntegrationCard: FC = () => {
  return (
    <div className='card h-100 w-100 d-flex flex-column'>
      <div className='card-header border-0 pt-5'>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px me-5'>
            <div className='symbol-label bg-light-warning'>
              <i className='fab fa-jira fs-2x text-warning'></i>
            </div>
          </div>
          <div className='d-flex flex-column'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold fs-4 mb-2'>Jira</span>
              <span className='text-muted mt-1 fw-semibold fs-7'>
                Gerenciamento ágil de projetos
              </span>
            </h3>
          </div>
        </div>
      </div>
      
      <div className='card-body pt-0 d-flex flex-column flex-grow-1'>
        <div className='mb-6 flex-grow-1'>
          <p className='text-muted fs-7 mb-4'>
            Integração com Jira para sincronizar issues, sprints e workflows. 
            Em desenvolvimento.
          </p>
          
          <div className='d-flex flex-column gap-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <span className='text-muted fs-7'>Status:</span>
              <span className='badge badge-light-secondary'>Em breve</span>
            </div>
          </div>
        </div>
        
        <div className='mt-auto'>
          <div className='d-flex flex-column gap-2'>
            <button
              className='btn btn-sm btn-secondary w-100'
              disabled
            >
              <i className='fas fa-clock me-2'></i>
              Em desenvolvimento
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JiraIntegrationCard
